import { ensureNoUndefinedProperties } from '@/Shared/Helper/EnsureNoUndefinedProperties'
import Booking from '@/App/Booking/Booking/Entity/Booking'
import MeetingData from '@/App/Booking/Meeting/Entity/MeetingData'
import type { BookingDataRawDataMeeting } from '@/Shared/AutoGenerated/Main'

export default class BookingData {
    constructor(
        public readonly booking: Booking,
        public readonly meetingsData: MeetingData[],

        // Computed
        public readonly cannotBeCanceled: boolean,
    ) {
        ensureNoUndefinedProperties(this)
    }

    isRecurring(): boolean {
        return this.booking.isRecurring()
    }

    replaceUpdatedMeetingData(updatedMeetingData: MeetingData): BookingData {
        const updatedMeetingDatas = this.meetingsData.map(
            (meetingData: MeetingData) => {
                return updatedMeetingData.isSame(meetingData)
                    ? updatedMeetingData
                    : meetingData
            },
        )

        return new BookingData(
            this.booking,
            updatedMeetingDatas,
            this.cannotBeCanceled,
        )
    }

    // ------------------------
    // Hydration
    // ------------------------

    static hydrateSingle(entityData: BookingDataRawDataMeeting): BookingData {
        return new BookingData(
            Booking.hydrateSingle(entityData.booking),
            MeetingData.hydrateMultiple(entityData.meetingsData),
            entityData.cannotBeCanceled,
        )
    }
}
